import { html, LitElement } from 'lit';
import { IxLabelTagStyles } from './ix-label-tag-styles.js';

export class IxLabelTag extends LitElement {
  static get styles() {
    return [IxLabelTagStyles];
  }

  render() {
    return html`<span class="label-tag">
      <slot></slot>
    </span>`;
  }
}
